import { API_URL } from "./_base";

const themeData = {
  '--sonaris-color-primary': '#b2a5ff',
  '--sonaris-color-secondary': '#493d9e',
  '--sonaris-color-text': '#f2f2f2',
};

export async function fetchConfiguration(website_id: string) {
  const url = new URL(API_URL)
  url.pathname = `/data/get_char_and_tools/${website_id}`

  const resp = await fetch(url)

  const data = await resp.json();
  if (resp.status > 200) {
    console.error(data)
    throw new Error(data.detail)
  }

  data.theme = themeData;

  return data
}
